import DebugService from './DebugService';
import config from '../configs';

/**
 * Handled values of status in API responses
 */
const API_STATUS = {
  PROCESSING : 'processing',  // QUERY : traitement lancé
  DELAYED : 'delayed',  // CHECK_ANSWER : traitement de réponse back en cours, asynchrone
  ACTIVE : 'active',  // CHECK_ANSWER : traitement de réponse back fait, recupérable
  COMPLETED: 'completed',  // CHECK_ANSWER : traitement de réponse back fait, recupérable ET intention répondue, trigger continue
  ABORTED: 'aborted',  // CHECK_ANSWER : demande user de fin de conversation, message de l'agent, trigger notation
  TERMINATED : 'terminated',  // RATE : session back terminée et close
  ERROR : 'error' // ALL : traitement en erreur
};


/**
 * API
 * @folder APIs
 * @class
 */
class Api {

  ENDPOINT_HELLO = 'api/chat/hello';
  ENDPOINT_QUERY = 'api/chat/query';
  ENDPOINT_CHECK_ANSWER = 'api/chat/check_answer';
  ENDPOINT_RATE = 'api/chat/rate';

  DEBUG = DebugService.getInstance().enabled;

  /**
   * @param {string} token Not needed is 'asnidren' mode
   * @returns {Promise}
   * contenant un json { "message": "Hello" }
   */
  getHello(token) {
    if (this.DEBUG) console.log("Api - getHello");
    if (this.DEBUG) console.log("Api - getHello",{env:process.env.REACT_APP_ENV});
    if (this.DEBUG) console.log("Api - getHello",{api_url:process.env.REACT_APP_API_URL});
    if (this.DEBUG) console.log("Api - getHello",{api_need_token:process.env.REACT_APP_API_NEED_TOKEN});
    if (this.DEBUG) console.log("Api - getHello",{api_suffix:process.env.REACT_APP_API_ENDPOINTS_SUFFIX});

    const API_URL = process.env.REACT_APP_API_URL;
    const API_NEED_TOKEN = process.env.REACT_APP_API_NEED_TOKEN === undefined || process.env.REACT_APP_API_NEED_TOKEN ? true : false;
    const API_ENDPOINT_SUFFIX = process.env.REACT_APP_API_ENDPOINTS_SUFFIX ? process.env.REACT_APP_API_ENDPOINTS_SUFFIX : '';

    let params = {};
    if (!API_NEED_TOKEN) {  // cas serveur mode mock
      params = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      };
    }
    else {
      params = {
        method: 'GET',
        headers: {
          'X-Agent-ID': token,
          'Content-Type': 'application/json'
        }
      };
    }

    // L'URL c'est l'url de base sur laquelle on concatene le endpoint
    // en mode "asnidren" (serveur mock), ca ne charge pas le index par defaut, du coup je rajoute le suffix "index.json"
    let URL = API_URL + this.ENDPOINT_HELLO + API_ENDPOINT_SUFFIX;

    return this._customFetch(URL,params);
  }

  /**
   *
   * @param {string} token Not needed is 'asnidren' mode
   * @param {string} session_id
   * @param {object} userdata Ex: {"query":"user query"}
   * @returns {Promise}
   */
  postQuery(token, session_id, userdata) {
    const API_URL = process.env.REACT_APP_API_URL;
    const API_NEED_TOKEN = process.env.REACT_APP_API_NEED_TOKEN === undefined || process.env.REACT_APP_API_NEED_TOKEN ? true : false;
    const API_ENDPOINT_SUFFIX = process.env.REACT_APP_API_ENDPOINTS_SUFFIX ? process.env.REACT_APP_API_ENDPOINTS_SUFFIX : '';

    let params = {};
    if (!API_NEED_TOKEN) {
      params = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(userdata),
      };
    }
    else {
      params = {
        method: 'POST',
        headers: {
          'X-Agent-ID': token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(userdata),
      };
    }

    // L'URL c'est l'url de base sur laquelle on concatene le endpoint
    // en mode "asnidren" (serveur mock), ca ne charge pas le index par defaut, du coup je rajoute le suffix "index.json"
    let URL = API_URL + this.ENDPOINT_QUERY + (!!session_id ? '/' + session_id : '') + API_ENDPOINT_SUFFIX;

    return this._customFetch(URL,params);
  }

  /**
   *
   * @param {string} token
   * @param {string} session_id
   * @param {string} process_id
   * @returns {Promise}
   */
  getCheckAnswer(token, session_id, process_id) {
    const API_URL = process.env.REACT_APP_API_URL;
    const API_NEED_TOKEN = process.env.REACT_APP_API_NEED_TOKEN === undefined || process.env.REACT_APP_API_NEED_TOKEN ? true : false;
    const API_ENDPOINT_SUFFIX = process.env.REACT_APP_API_ENDPOINTS_SUFFIX ? process.env.REACT_APP_API_ENDPOINTS_SUFFIX : '';

    let params = {};
    if (!API_NEED_TOKEN) {
      params = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
      };
    }
    else {
      params = {
        method: 'GET',
        headers: {
          'X-Agent-ID': token,
          'Content-Type': 'application/json'
        },
      };
    }

    // L'URL c'est l'url de base sur laquelle on concatene le endpoint
    // en mode "asnidren" (serveur mock), ca ne charge pas le index par defaut, du coup je rajoute le suffix "index.json"
    let URL = API_URL + this.ENDPOINT_CHECK_ANSWER + (!!session_id ? '/' + session_id : '/?') + (!!process_id ? '/' + process_id : '/') + API_ENDPOINT_SUFFIX;

    return this._customFetch(URL,params);
  }


  /**
   *
   * @param {string} token Not needed is 'asnidren' mode
   * @param {string} session_id
   * @param {object} userdata Ex: {"rate":"4"}
   * @returns {Promise}
   */
  postRate(token, session_id, userdata) {
    const API_URL = process.env.REACT_APP_API_URL;
    const API_NEED_TOKEN = process.env.REACT_APP_API_NEED_TOKEN === undefined || process.env.REACT_APP_API_NEED_TOKEN ? true : false;
    const API_ENDPOINT_SUFFIX = process.env.REACT_APP_API_ENDPOINTS_SUFFIX ? process.env.REACT_APP_API_ENDPOINTS_SUFFIX : '';

    let params = {};
    if (!API_NEED_TOKEN) {
      params = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(userdata),
      };
    }
    else {
      params = {
        method: 'POST',
        headers: {
          'X-Agent-ID': token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(userdata),
      };
    }

    // L'URL c'est l'url de base sur laquelle on concatene le endpoint
    // en mode "asnidren" (serveur mock), ca ne charge pas le index par defaut, du coup je rajoute le suffix "index.json"
    let URL = API_URL + this.ENDPOINT_RATE + (!!session_id ? '/' + session_id : '') + API_ENDPOINT_SUFFIX;

    return this._customFetch(URL,params);
  }


  /**
   * Fetch custom, enable to stop the request after a timeout
   * @param {string} url
   * @param {object} options
   * @param {number} timeout
   * @returns {Promise}
   */
  async _customFetch(url, options, timeout = process.env.REACT_APP_API_URL === 'http://project.eurelis.local:8080/' ? 50000 : 16000) {
    const controller = new AbortController();
    const id = setTimeout(() => {
      controller.abort();
      if (this.DEBUG) console.log("API - _customFetch - Request timed out ("+timeout+")", url);
    }, timeout);

    try {
      const response = await fetch(url, {
        ...options,
        signal: controller.signal
      })
      clearTimeout(id);
      if (this.DEBUG) console.log("API - _customFetch - Request", url, "returned", response);
      if (!response.ok) {
        if (this.DEBUG) console.log(`API - _customFetch - HTTP error! status: ${response.status}`);
        return response;
      }
      return response;
    }
    catch (error){  // intercepte une 500
      console.error('API - _customFetch - An error occured',{error});
      return {
        ok: false,
        status: 500,
        statusText: undefined,
        error: error,
        body: {}
      };
    }
  }
}

export default Api;
export {API_STATUS};
